'use client';

import type { ID } from '@segment/analytics-next';
import { createContext } from 'react';

export const AnonymousContext = createContext<ID>(null);
